module.exports = __webpack_public_path__ + "static/media/logo-startup.c8c4f3ef.png";